import EATextField from "../EATextField";
import EAButton from "../EAButton";
import React from "react";
import EAFieldset from "../EAFieldset";
import EAButtonBar from "../EAButtonBar";
import EACheckbox from "../EACheckbox";

/**
 * Komponente zur Filterung einer Anwenderliste
 * @param filterProps
 * @param onFilterPropsChange
 * @param onFilter
 * @param onFilterReset
 * @returns {JSX.Element}
 * @constructor
 */
function AnwenderListFilter({filterProps, onFilterPropsChange, onFilter, onFilterReset}) {

    function createFilterField(filterProp, label) {
        return <EATextField value={filterProps[filterProp]} onChange={e => onFilterPropsChange(filterProp, e.target.value)}
                            id={"anwenderFilter" + label} label={label}/>
    }

    function createFilterCheckbox(filterProp, label) {
        return <EACheckbox checked={filterProps[filterProp]} onChange={(_e, checked) => onFilterPropsChange(filterProp, checked)}
                           id={"anwenderFilter" + label}>{label}</EACheckbox>
    }

    return (
        <EAFieldset caption="Suche">
            <div className="gridl anwenderlist-filter">
                {createFilterField("vorname", "Vorname")}
                {createFilterField("name", "Name")}
                {createFilterField("organisation", "Organisationsbezeichnung")}
                <div></div>
            </div>
            <div className="anwenderlist-filter-checkboxes">
                <span className={"anwenderlist-filter-status"}>Status</span>
                {createFilterCheckbox("statusBeantragt", "beantragt")}
                {createFilterCheckbox("statusBestaetigt", "bestätigt")}
                {createFilterCheckbox("statusAktiv", "aktiv")}
                {createFilterCheckbox("statusInaktiv", "inaktiv")}
                <span className={"anwenderlist-filter-rolle"}>Rolle</span>
                {createFilterCheckbox("rolleOrganisation", "Organisation")}
                {createFilterCheckbox("rolleBehoerde", "Behörde")}
                {createFilterCheckbox("rolleAdministration", "Administration")}
            </div>
            <div>
                <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                    <EAButton onClick={onFilterReset} id="anwenderFilterSucheReset" label="Zurücksetzen"/>
                    <EAButton onClick={onFilter} id="anwenderFilterSuche" label="Suchen" color="primary"/>
                </EAButtonBar>
            </div>
        </EAFieldset>
    );
}

export default AnwenderListFilter;
